import axios from "axios"
import Moment from 'moment'
import { extendMoment } from 'moment-range';
import ApiStore from "./ApiStore";
const moment = extendMoment(Moment);

var querystring = require('querystring');

export class MessageStore extends ApiStore{
  constructor() {
    super();

  }

  loadStatMessage(completeFunc,errorFunc) {
    axios.get('/message/stat_message')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error);
    })
  }

  loadUnreadMessage(completeFunc,errorFunc) {
    axios.get('/message/unread_message')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error);
    })
  }

  loadAllMessage(completeFunc,errorFunc) {
    axios.get('/message/all_message')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error);
    })
  }

  newMessage(param,completeFunc,errorFunc){
    let postData = param
    console.log('newMessage',postData)
    axios.post('/message/new_message',postData)
    .then(function(response){
      console.log(response)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateReadMessage(msgId,completeFunc,errorFunc){
    
    
    axios.post('/message/mark_read_message/'+msgId,{})
    .then(function(response){
      console.log(response)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  archiveMessage(msgId,completeFunc,errorFunc){
    
    
    axios.post('/message/archive_message/'+msgId,{})
    .then(function(response){
      //console.log(response)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  archiveAllReadMessage(completeFunc,errorFunc){
    
    
    axios.post('/message/archive_all_read/',{})
    .then(function(response){
      //console.log(response)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  postApi(url,payload,completeFunc,errorFunc){
    axios.post(url,payload)
    .then(function(response){
      console.log(response)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadLineMessage(year,month,day,cat,query,start,length,completeFunc,errorFunc) {
    year = year - 543
    axios.get('/linemessage/messages/C142680cb882c4e9b2820372b543f36ed?year='+year+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error);
    })
  }

  loadLineMessageRange(start_date,end_date,cat,query,start,length,completeFunc,errorFunc) {
    axios.get('/linemessage/messages/C142680cb882c4e9b2820372b543f36ed?start_date='+start_date+'&end_date='+end_date+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error);
    })
  }
  
}

export default new MessageStore()



// WEBPACK FOOTER //
// ./src/stores/MessageStore.js